import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet'
import { Button } from './ui/button'
import { Badge } from './ui/badge'
import { Separator } from './ui/separator'
import { Minus, Plus, Trash2, ShoppingCart as ShoppingCartIcon } from 'lucide-react'
import { ImageWithFallback } from './figma/ImageWithFallback'
import { Tire } from './TireCard'
import { CatalogItem, CatalogItemListReq, PropertyFilter } from '../types/catalog'; 
import { CartProdInfo } from './CartProdInfo'
import { catalogClient } from '../services/grpc';
import { CartReq,CartAddReq,CartRemoveReq,CartRes } from '../generated/catalog_pb'; 
import Cookies from 'js-cookie'
import { Input } from './ui/input'
export interface CartItem {
  tire: CatalogItem
  quantity: number
}

interface ShoppingCartProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  cartItems: CartItem[]
  onUpdateQuantity: (tireId: number, quantity: number) => void
  onRemoveItem: (tireId: number) => void
  onOrder:()=>void
  customerName: string
  customerPhone:string
  setCustomerName:(customerName:string)=>void
  setCustomerPhone:(customerPhone:string)=>void
}

export function ShoppingCart({ 
  isOpen, 
  onOpenChange, 
  cartItems = [], // Default to empty array
  onUpdateQuantity, 
  onRemoveItem,
  onOrder,
  customerName,
  customerPhone,
  setCustomerName,
  setCustomerPhone
}: ShoppingCartProps) {
  let req=false;
  if (cartItems.length==0) {
    const guid = Cookies.get('guid');
    if (typeof guid === 'string'&&req==false) {
      req=true;
      const cartReq = new CartReq();
      cartReq.setGuid(guid);
      catalogClient.getCart(cartReq, {}, (err, response) => {
        if (cartItems.length==0) {
        if (err) {
          console.error('Error fetching cart:', err.code, err.message);
        } else {
           const items = response.getItemsList();
           items.forEach((item) => {
            cartItems.push({
              tire: {
                id: item.getProductId(),
                name: item.getName(),
                price: item.getPrice(),
                pic: item.getPic(),
                qty: item.getQty(),
                code: '',
                desc: '',
                title: item.getSize()
              },
              quantity: item.getQty(),
            });
          });    
        }}
      });
    }
  }
  const safeCartItems = cartItems || []
  const totalItems = safeCartItems.reduce((sum, item) => sum + item.quantity, 0)
  const totalPrice = safeCartItems.reduce((sum, item) => sum + (item.tire.price * item.quantity), 0)

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-lg">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <ShoppingCartIcon className="h-5 w-5" />
            Ваша корзина ({totalItems})
          </SheetTitle>
        </SheetHeader>
        
        <div className="mt-6 space-y-4">
          {safeCartItems.length === 0 ? (
            <div className="text-center py-8">
              <ShoppingCartIcon className="h-12 w-12 mx-auto text-gray-400 mb-4" />
              <p className="text-gray-500">В корзине ничего нет.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 max-h-96 overflow-y-auto">
                {safeCartItems.map((item) => (
                  <div key={item.tire.id} className="flex items-center space-x-4 p-4 border rounded-lg">
                    <ImageWithFallback
                      src={item.tire.pic}
                      alt={item.tire.name}
                      className="w-16 h-16 object-cover rounded"
                    />
                    <CartProdInfo product={item.tire}/>                                
                    <div className="flex flex-col items-end space-y-2">
                      <div className="flex items-center space-x-1">
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => onUpdateQuantity(item.tire.id, Math.max(0, item.quantity - 1))}
                          className="h-8 w-8 p-0"
                        >
                          <Minus className="h-3 w-3" />
                        </Button>
                        <Badge variant="outline" className="min-w-8 text-center">
                          {item.quantity}
                        </Badge>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => onUpdateQuantity(item.tire.id, item.quantity + 1)}
                          className="h-8 w-8 p-0"
                        >
                          <Plus className="h-3 w-3" />
                        </Button>
                      </div>
                      
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => onRemoveItem(item.tire.id)}
                        className="h-8 w-8 p-0 text-red-500 hover:text-red-700"
                      >
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
              
              <Separator />
              
              <div className="space-y-4">
                <div className="flex justify-between items-center inline-flex items-center justify-center pl-4">
                  <span className="font-semibold items-center inline-flex items-center justify-center">Итого: {totalPrice.toFixed(2)}₽</span>
                </div>
                <div className="space-y-2 p-3">
                <div>
    <label htmlFor="fio" className="block text-sm font-medium mb-1">Ваше имя:</label>
    <Input 
      id="fio"
      name="fio"
      value={customerName}
      placeholder="Петров Сидор Васильевич"
      className="w-full   placeholder:text-black/70" 
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomerName(e.target.value)}
    />
  </div>

  <div>
    <label htmlFor="phone" className="block text-sm font-medium mb-1">Номер вашего телефона</label>
    <Input 
      id="phone"
      name="phone"
      value={customerPhone}
      type="tel"
      placeholder="+7 (999) 111-22-33"
      className="w-full   placeholder:text-black/70" 
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomerPhone(e.target.value)}
    />
  </div>
                </div>
                <div className="space-y-2">
                  <Button className="w-full bg-[#ed8510] hover:bg-[#d97009] text-white" size="lg" onClick={() =>onOrder()}>
                    Оформить заказ
                  </Button>
                  <Button variant="outline" className="w-full" onClick={() =>  onOpenChange(false)}>
                    Продолжить покупки 
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
}